import { AbstractController } from "./abstract-controller";
import { Attestation, BwObjectPromise, CompromiseReports, BwFilters,  } from "../../service/global.service";
import { Environment } from "../environment";
export class AttestationController extends AbstractController {
  private readonly service: string = "api/v1.0/attestations";
  private readonly apiUrl: keyof Environment = "bwApiUrl";

  public async search(filters: BwFilters): Promise<BwObjectPromise> {
    return await this.network.post(`${this.service}/search`, filters, this.apiUrl);
  }

  isAttestation(object: BwObjectPromise | undefined) {
    let listResult: Array<CompromiseReports | Attestation> | undefined= JSON.parse(object!.results);
    return Array.isArray(listResult) && listResult.every(item => 'metadata' in item || 'probes' in item);
  }

}
